/* eslint-disable no-useless-escape */
import { layers } from './layers';
import { filters } from './filters';
import { parcelReport } from './parcel-report';
import { subunits } from './subunits';

export default {
  city: 'Place Impact',
  state: 'MI',
  type: 'Neighborhood Intel',
  isPublic: true,
  center: {
    lat: 42.35613415551762,
    lng: -83.06151801073753,
  },
  zoom: 13.348052930261732,
  allowFavorites: false,
  canSignUp: true,
  layers,
  information: `
### Neighborhood Intel: Place Impact
![Dynamo Metrics](https://www.dynamo.city/medc-public/img/dynamo-primary-logo.png)
![MEDC](https://www.dynamo.city/medc-public/img/medc-logo.png)

**Welcome to the preview of Dynamo Metrics’ Neighborhood Intel: Place Impact software!**

This platform provides a preview of the [new software](https://www.dynamometrics.com/place-impact) developed by Dynamo Metrics to measure the impact of place-based investments and visualize the findings from the *[Quantifying the Placemaking Effect](https://www.dynamometrics.com/place-impact#quantifying-the-placemaking-effect)* report.\*

Use the menu on the left to search for properties by address and view map layers. To view the details for a specific investment property, simply click that property on the map. For the best experience, use this tool on a desktop or tablet.

**Project Background:**

Michigan Economic Development Corporation (MEDC) chose Dynamo Metrics to quantify the impacts of its place-based investments on nearby neighborhoods and commercial corridors. The resulting report, *[Quantifying the Placemaking Effect](https://www.dynamometrics.com/place-impact#quantifying-the-placemaking-effect)*, provides a first-of-its-kind evaluation of the impact [community development incentives](https://www.miplace.org/programs/) have on occupancy and property value in Michigan's communities.

Findings from the report are built into a comprehensive software, Neighborhood Intel: Place Impact, which empowers MEDC to evaluate the impact of future investments to target and measure their placemaking work.

**[Read the full report and learn more here.](https://www.dynamometrics.com/place-impact)**

\**This preview only provides a sample of the projects, data, and features included in the MEDC Neighborhood Intel: Place Impact software.*
  `,
  filters,
  defaultSidebar: 'INFORMATION',
  sidebarFlags: [
    'INFORMATION',
    'GOOGLE_PLACES',
    'LAYER_SELECTOR',
    'LAYER_BUILDER_LOCKED',
  ],
  subunits,
  customLayersConfig: {
    styleTypeOptions: ['line', 'fill', 'circle'],
    defaultStyle: {
      type: 'line',
      opacity: 0.8,
      paint: {
        'line-color': '#E2603B',
      },
    },
  },
  reports: [parcelReport],
};
